import { GoogleChartsModule } from 'angular-google-charts';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DxTemplateModule, DxButtonModule, DxDataGridModule, DxCheckBoxModule, DxSelectBoxModule, DxTreeListModule, DxFormModule, DxPopoverModule, DxPopupModule } from 'devextreme-angular';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MatDividerModule, MatInputModule, MatFormFieldModule, MatButtonModule, MatOptionModule, MatSelectModule } from '@angular/material';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimsRoutingModule } from './sims-routing.module';
import { MatIconModule } from '@angular/material/icon';


import { SimsComponent } from './sims.component';
import { SimComponent } from './components/sim/sim.component';
import { AltaSimComponent } from './components/sim/alta-sim/alta-sim.component';
import { BotonExportarTablaComponent } from '../reutilizables/components/boton-exportar-tabla/boton-exportar-tabla.component';
import { ReutilizablesModule } from '../reutilizables/reutilizables.module';


@NgModule({
	declarations: [
		SimsComponent,
		SimComponent,
		AltaSimComponent,
		//BotonExportarTablaComponent
	],
	imports: [
		CommonModule,
		SimsRoutingModule,
		MatDividerModule,
		MatCheckboxModule,
		FormsModule,
		MatInputModule,
		MatFormFieldModule,
		MatButtonModule,
		MatOptionModule,
		MatSelectModule,
		MatListModule,
		MatSlideToggleModule,
		MatIconModule,
		DxTemplateModule,
		DxButtonModule,
		DxDataGridModule,
		DxCheckBoxModule,
		DxSelectBoxModule,
		DxTreeListModule,
		DxFormModule,
		DxPopoverModule,
		DxPopupModule,
		//ReutilizablesModule,
		ReactiveFormsModule,
		GoogleChartsModule.forRoot(),
		NgxPermissionsModule,
		ReutilizablesModule,

	],
	exports: [
		FormsModule,
		ReactiveFormsModule
	]

})
export class SimsModule { }
